import React from 'react';
import { City } from '../../types/city';
import CityCard from './CityCard';

interface CityCardListProps {
  cities: City[];
  onCityClick: (city: string) => void;
}

const CityCardList: React.FC<CityCardListProps> = ({ cities, onCityClick }) => {
  return (
    <div className="flex flex-col space-y-6">
      {cities.map(city => (
        <div key={city.name}>
          <CityCard
            city={city.name}
            image={city.image}
            active={city.active}
            onClick={() => onCityClick(city.name)}
          />
        </div>
      ))}
    </div>
  );
};

export default CityCardList;
